import React from "react";
import favIco from "../../assets/img/fav_icon.png";

// In-page loader for lists and forms: a gold ring around the brand mark.
// `page`: it stands for a page's main content, so it holds a screen's
// height and what follows (the sidebar, the footer) starts below the fold
// instead of jumping down when the content arrives (layout shift).
export default function ComponentsLoader({ page = false }) {
  return (
    <div className={page ? "avc-loader avc-loader--page" : "avc-loader"} role="status" aria-live="polite">
      <span className="avc-loader__ring">
        <img className="avc-loader__mark" src={favIco} alt="" />
      </span>
      <span className="avc-sr-only">Loading</span>
    </div>
  );
}
